import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=cf39796c&scoped=true&"
import script from "./role-list.vue?vue&type=script&lang=js&"
export * from "./role-list.vue?vue&type=script&lang=js&"
import style0 from "./role-list.vue?vue&type=style&index=0&id=cf39796c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf39796c",
  null
  
)

export default component.exports